// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"W4-z","dimensionLabel":"X4-z","styleChooserControlWrapper":"Y4-z","styleChooserControl":"Z4-z","disabled":"_4-z","giftCard":"a5-z","styleChooserText":"b5-z"};